export const CHECKOUT_LIVING_SITUATION = '/living-situation';
export const CHECKOUT_CONDO_DETAILS = '/condo-details';
export const CHECKOUT_LIVING_CONDITION = '/living-condition';
export const CHECKOUT_CONDOMINIMUM_ADDON = '/condominium-addon';
export const CHECKOUT_PLUS_ADDON = '/plus-addon';
